import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {LockerDetailWIB} from '../models/lockerDetailsWIB';
import {credentialHttpOptionsJson} from '../http.options';
import {LockerDetailMGT} from '../models/lockerDetailsMGT';

@Injectable({
  providedIn: 'root'
})
export class LockersService {

  apiUrl = environment.apiCoreUrl + '/locker-management';

  constructor(private http: HttpClient) { }

  getLockers(): Observable<any> {
    return this.http.get<any>(this.apiUrl, credentialHttpOptionsJson);
  }

  updateLocker(lockerDetail: LockerDetailWIB | LockerDetailMGT): Observable<LockerDetailWIB | LockerDetailMGT> {
    return this.http.post<LockerDetailWIB | LockerDetailMGT>(this.apiUrl, lockerDetail, credentialHttpOptionsJson);
  }

  createLocker(lockerDetail: LockerDetailWIB | LockerDetailMGT): Observable<LockerDetailWIB | LockerDetailMGT> {
    return this.http.post<LockerDetailWIB | LockerDetailMGT>(this.apiUrl +  '/new', lockerDetail, credentialHttpOptionsJson);
  }

  validateLocker(lockerDetail: LockerDetailWIB | LockerDetailMGT): Observable<LockerDetailWIB | LockerDetailMGT> {
    return this.http.post<LockerDetailWIB | LockerDetailMGT>(this.apiUrl +  '/validate', lockerDetail, credentialHttpOptionsJson);
  }

  getLockerById(lockerId: number): Observable<LockerDetailWIB | LockerDetailMGT> {
    return this.http.get<LockerDetailWIB | LockerDetailMGT>(this.apiUrl + '/' + lockerId, credentialHttpOptionsJson);
  }

  deleteLockerById(lockerId: number): Observable<any> {
    return this.http.delete<any>(this.apiUrl + '/' + lockerId, credentialHttpOptionsJson);
  }

  configureLocker(id: number): Observable<any> {
    return this.http.post<LockerDetailWIB | LockerDetailMGT>(this.apiUrl + '/configure/' + id, credentialHttpOptionsJson);

  }

}
